import { request } from '@kibt/krn-utils';
import { api } from '@/common/api';
import { getQuery, SCENE } from '@/common/const';

// import { useQuery } from '@/hooks/useQuery';

const scene = getQuery('scene') as string;

// 特殊的领券渠道 需要传对应的scene参数给领券接口
const claimCouponSceneMap = {
    102: 102, // 分销寄样来源
};

/**
 * 领取自建优惠劵
 */
export function postClaimCoupon(params: { batchId: number | string }) {
    const claimScene = claimCouponSceneMap[scene] || SCENE.DEFAULT_SCENE; // 默认值0
    return request.post(api(`/rest/o/ecommerce/marketing/c/customer/coupon/claim?batchId=${params.batchId}&scene=${claimScene}`)).then(res => {
        if (res.result === 1) {
            return res;
        } else {
            return Promise.reject(res);
        }
    });
}
